<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M5 8H6M8.99268 8H19.9927" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M5 12H6M8.99268 12H19.9927" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M5 16H6M8.99268 16H19.9927" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
</svg>
